import clsx from 'clsx';

import Icon from '../Icon';
import Button from '../Button';
import { notify } from '../../shared';
import type { ButtonProps } from '../Button';

export const onCopy = (message = 'Text copied successfully.') =>
  notify.success(message);

export const copyToClipboard = async (
  text: string,
  message = 'Text copied successfully.'
): Promise<boolean> => {
  try {
    await navigator.clipboard.writeText(text);

    onCopy(message);
    return true;
  } catch (err) {
    console.error('Failed to copy: ', err);
    return false;
  }
};

type CopyProps = {
  text?: string;
  message?: string;
  className?: string;
  label?: string | boolean;
};

export const Copy: React.FC<CopyProps> = ({
  text,
  label,
  message,
  className,
}) => {
  return (
    <span
      onClick={text ? () => copyToClipboard(text, message) : undefined}
      className={clsx(
        className,
        text ? 'cursor-pointer' : '',
        label ? 'flex items-center gap-x-sm' : ''
      )}
    >
      <Icon icon="copy" />
      {label && <div className="shrink-0">{label}</div>}
    </span>
  );
};

type CopyButtonProps = ButtonProps & {
  copy: string;
};

export const CopyButton: React.FC<CopyButtonProps> = ({
  copy,
  label,
  ...rest
}) => {
  return (
    <Button
      {...rest}
      icon="copy"
      tooltip="Copy Prompt"
      label={label ?? 'Copy'}
      onClick={copy ? () => copyToClipboard(copy, 'Prompt copied!') : undefined}
    />
  );
};
